import React from 'react'
import { COLORES } from '../../../config/colores'
import { Button } from '@material-ui/core'
import { getFormValues, reset, initialize } from 'redux-form'
import { CupoService } from '../../../models/cupo/service/cuposService'
import { CupoUtils } from '../../../models/cupo/service/cuposUtils'
import { FORM_CUPO, FORM_NOMINACION_CUPO, FORM_CONTACTO, FORM_EDICION_CONTACTO, FORM_CUPO_MULTIPLE, FORM_EDICION_CANTIDAD_CUPO } from '../../../config/forms'
import { EMPTY_CUPO } from './constants'
import { Autocomplete } from '../../../models/autocomplete/autocomplete'
import { TABLE_CUPOS, TABLE_CUPOS_NOMINADOS, TABLA_CUPOS_A_ASIGNAR, TABLA_CORREOS_UPDATE, TABLE_CUPOS_HISTORICO, TABLE_CUPOS_DISPONIBLES, TABLA_CACHE_CUPOS_A_NOMINAR, TABLA_CUPOS_ASIGNADOS } from '../../../config/tables'
import { getColumnasCuposAsignados, COLUMNS_CUPOS_HISTORICOS, COLUMNS_CUPOS_HISTORICOS_EXPORTADOR, CUPOS_ASIGNADOS_TO_PRINT, columnasCuposAsignados } from './TablaCuposVigentesConstants'
import { COLUMNS_NOMINADO_CACHE, COLUMNS_DISPONIBLES } from './TablaNominacionMultiple'
import { COLUMNS_CUPOS_PARA_ASIGNAR, COLUMNS_CUPOS_PARA_ASIGNAR_TO_PRINT } from './TablaCuposParaAsignar'
import { COLUMNS_CORREOS_EXPORTADOR, COLUMNS_CORREOS_EXPORTADOR_TO_PRINT } from './TablaCorreosExportador'
import moment from 'moment'
import NewAsignacionDialog from '../containers/asignacionCupos/NewAsignacionDialog'
import BloqueoDeCuposDialog from '../components/BloqueoDeCuposDialog'
import EditAsignacionDialog from '../containers/asignacionCupos/EditAsignacionDialog'
import NominacionDeCuposDialog from '../containers/asignacionCupos/NominacionDeCuposDialog'
import NominacionDeCuposMultiplesDialog from '../containers/asignacionCupos/NominacionDeCuposMultiplesDialog'
import RenominacionDeCuposDialog from '../containers/nominacionCupos/RenominacionDeCuposDialog'
import { toast } from 'react-toastify'
import DialogView from '../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../Dialogos/DialogConfirmacionContent'
import DetalleCodigoDeCupo from '../containers/consultaCodigoDeCupos/components/DetalleCodigoDeCupo'
import { CreateAuthz } from '../../Authz/containers/AuthzHocCreator'
import { COMPONENT_PERMS } from '../../Authz/types'
import CorreoElectronico from '../../../models/correoElectronico/correoElectronico'
import CorreoCargador from '../../../models/correoElectronico/correoCargador'
import { pdfCustomToolbarGenerator } from '../../../models/tools/generarPdf'
import { parseEntityId, parseEntityName } from '../../../models/entity'
import EmailIcon from '@material-ui/icons/Email'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import { CUPOS_NOMINADOS_TO_PRINT, getColumnasCuposNominados } from '../containers/nominacionCupos/constantes/constantesCuposNominados'
import CorreoCorredor from '../../../models/correoElectronico/correoCorredor'
import Cpa from '../../../models/camiones/cpa'
// import { actualizarDatosParaMuiTable } from '../containers/consultaCodigoDeCupos/actions/TablaConsultaCodigoDeCuposActions'
import { CodigoDeCupo } from '../../../models/cupo/codigoDeCupo'
import { PdfDownloadLinkReporteLaridae } from '../../Movimiento/shared/pdfDownloadLinkReporteLaridae/containers/pdfDownloadLinkReporteLaridae'
import ParametroInteger from '../../../models/parametro/parametro_integer'

export function requestTiposCupos () {
  // TODO CHECK HOW TO RETRIEVE THE TYPES FROM DE DATABASE
  // MOCKED FOR NOW
  return dispatch => {
    dispatch({
      type: 'REQUESTED_TIPOS_CUPOS',
      tiposCupos: [
        {
          nombreCorto: 'N',
          nombre: 'Nominado'
        },
        {
          nombreCorto: 'L',
          nombre: 'Libre'
        }
      ]
    })
  }
}

export function hideToast () {
  return dispatch => {
    dispatch({
      type: 'HIDE_TOAST'
    })
  }
}

export function openDialogNominacion (cupo) {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_CUPO_NOMINANDO',
      cupo: cupo
    })
    // dispatch(updateNominacionHastaField(cupo.fechaDeEmision))
    const confirmCallback = () => {
      submitNominacionDeCupos()(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'NOMINAR_CUPO'
      })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'NOMINAR_CUPO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'NOMINAR_CUPO',
      maxWidth: 'md',
      content: <NominacionDeCuposDialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
      />
    })
  }
}

export function openDialogNominacionMultiple () {
  return (dispatch, getState) => {
    const state = getState()
    const confirmCallback = () => {
      // if (state.cupos.cuposCacheNominados !== null && state.cupos.cuposCacheNominados.length > 0) {
      dispatch({ type: 'UPDATE_IS_REQUESTING_CUPOS', isRequestingCupos: true })
      submitNominacionDeCuposMultiples()(dispatch, getState)
      dispatch({ type: 'RESET_MUITABLE_CUPOS_DISPONIBLES' })
      dispatch({ type: 'RESET_PRECARGA_NOMINACION' })
      dispatch({ type: 'OPEN_NOTIFICACION' })
      // clearNominacionCache(state.auth.username)(dispatch)
      // dispatch({ type: 'RESET_MUITABLE_CUPOS_CACHE' })
      dispatch({ type: 'RESET_CUPOS_A_NOTIFICAR_CARGADOR' })
      dispatch({ type: 'RESET_CUPOS_A_NOTIFICAR_CORREDOR' })
      dispatch({ type: 'RESET_CORREO_CARGADOR' })
      dispatch({ type: 'RESET_CORREO_CORREDOR' })
      // } else {
      //   toast.error('No existen cupos para nominar')
      // }
      // dispatch({
      //   type: 'CLOSE_DIALOG',
      //   id: 'NOMINAR_CUPO'
      // })
      // dispatch(updateTablaDeAsignacionDeCupos(state.auth.roles))
    }
    const cancelCallback = () => {
      dispatch({ type: 'RESET_MUITABLE_CUPOS_DISPONIBLES' })
      dispatch({ type: 'RESET_PRECARGA_NOMINACION' })
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'NOMINAR_CUPO'
      })
      if (state.cupos.cuposCacheNominados !== null) {
        clearNominacionCache(state.auth.username)(dispatch)
        dispatch({ type: 'RESET_MUITABLE_CUPOS_CACHE' })
        dispatch({ type: 'RESET_CUPOS_A_NOTIFICAR_CARGADOR' })
        dispatch({ type: 'RESET_CUPOS_A_NOTIFICAR_CORREDOR' })
        dispatch({ type: 'RESET_CORREO_CARGADOR' })
        dispatch({ type: 'RESET_CORREO_CORREDOR' })
      }
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'NOMINAR_CUPO',
      maxWidth: 'lg',
      content: <NominacionDeCuposMultiplesDialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
      />
    })
  }
}

export function openDialogRenominacion (cupo) {
  return (dispatch, getState) => {
    setCurrentCupoRenominando(cupo)(dispatch)
    const confirmCallback = () => {
      submitRenominacionDeCupos()(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'RENOMINAR_CUPO'
      })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'RENOMINAR_CUPO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'RENOMINAR_CUPO',
      maxWidth: 'md',
      content: <RenominacionDeCuposDialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
      />
    })
    dispatch({
      type: 'OPEN_RENOMINACION',
      cupo: cupo
    })
  }
}

// export async function updateNominacionHastaField (fechaHasta) {
//   return dispatch => {
//     dispatch(change(FORM_CUPO, 'repetirNominacionHasta', fechaHasta))
//   }
// }

// export function updateTablaTotalCuposAsignados () {
//   return dispatch => {
//     dispatch({
//       type: 'UPDATE_MUITABLE',
//       newState: {
//         isLoading: true
//       },
//       id: TABLE_TOTAL_CUPOS_ASIGNADOS
//     })

//     CupoService.getTotalCuposAsignadosVigentes().then(callback)
//     function callback (data) {
//       const customToolbar = null

//       dispatch({
//         type: 'UPDATE_MUITABLE',
//         newState: {
//           columns: COLUMNS_TOTAL_CUPOS_VIGENTES,
//           data: data,
//           title: `Total cupos asignados vigentes`,
//           isLoading: false,
//           fixed2Decimales: false,
//           extraOptions: { customToolbar, print: false, pagination: false, download: false, search: false, viewColumns: false, filter: false }
//         },
//         id: TABLE_TOTAL_CUPOS_ASIGNADOS
//       })
//     }
//   }
// }

export function obtenerTotalCuposVigentes () {
  return (dispatch) => {
    return CupoService.getTotalCuposAsignadosVigentes()
      .then((data) => {
        dispatch({ type: 'RECEIVE_TOTAL_CUPOS', data })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function updateTablaDeAsignacionHistorico (fechaD, fechaH, rol = null) {
  let rolExportador = false

  if (rol) {
    rolExportador = (rol[0] === 'EXPORTADOR' || rol[1] === 'EXPORTADOR')
  }

  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_CUPOS_HISTORICO
    })

    CupoService.getCuposHistoricoEntreFechas(fechaD, fechaH).then(callback)
    function callback (data) {
      const customToolbar = null

      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: rolExportador ? COLUMNS_CUPOS_HISTORICOS_EXPORTADOR : COLUMNS_CUPOS_HISTORICOS,
          data: data,
          title: `Historico - Cupos asignados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: true, pagination: false, tableBodyMaxHeight: '499px' }
        },
        id: TABLE_CUPOS_HISTORICO
      })
    }
  }
}

export function parseDataAsignados (data) {
  const parsedData = []
  data && data.map(entry => {
    return parsedData.push({ ...entry, entry: entry })
  })
  return parsedData
}

export function updateTablaDeAsignacionDeCupos (roles) {
  return async (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_CUPOS
    })
    getCuposVigentes().then(callback)
    function callback (d) {
      const data = parseDataAsignados(d)
      const rolesAutorizantes = roles && roles.filter(rol => (rol === 'SUPERVISOR' || rol === 'ADMIN' || rol === 'DESARROLLADOR'))
      const isAdminCupos = rolesAutorizantes && rolesAutorizantes.length > 0

      const rolConsulta = roles && roles.find((r) => r === 'EXPORTADOR_CONSULTA')
      const soloConsulta = !!rolConsulta

      dispatch(saveCuposVigentes(data))
      const bloqueados = data.filter(cupo => cupo.habilitado === 'Bloqueado')
      const desbloqueados = data.filter(cupo => cupo.habilitado === 'Habilitado')

      const ButtonAsignacion = CreateAuthz(COMPONENT_PERMS['/cupos/asignacion'], false, false)(Button)
      const ButtonNominacionMultiple = CreateAuthz(COMPONENT_PERMS['/cupos/nominados'], false, false)(Button)

      // Botones que invocan metodos para asignar nuevos cupos, para bloquearlos o desbloquearlos
      const customToolbar = () => (
        <>
          <div style={{ marginBottom: '2%' }}>
            <div className='container-btn-toolbar-cupos'>

              {data.length > 0 && bloqueados.length > 0 && isAdminCupos && <div className='btn-toolbar-cupos'>
                <Button
                  style={{ width: '100%' }}
                  type=''
                  size='small'
                  variant='contained'
                  onClick={() => {
                    dispatch(desbloqueoDeCupos())
                  }}
                >
                      Desbloquear todos
                </Button>
              </div> }

              {data.length > 0 && desbloqueados.length > 0 && isAdminCupos && <div className='btn-toolbar-cupos'>
                <Button
                  style={{ width: '100%' }}
                  type=''
                  size='small'
                  variant='contained'
                  onClick={() => {
                    dispatch(openDialogBloqueoDeCupos())
                  }}
                >
                  Bloqueo de cupos
                </Button>
              </div> }

              { isAdminCupos && <div className='operaciones-cupos-asignados btn-toolbar-cupos'>
                <ButtonAsignacion
                  variant='contained'
                  style={{ color: COLORES.blue.primary, width: '100%', fontWeight: 'bold' }}
                  size='small'
                  onClick={() => { dispatch(openAsignacionCuposDialog()) }}
                >
                  ASIGNAR NUEVO
                </ButtonAsignacion>
              </div> }

              {!soloConsulta &&
                <div className='operaciones-cupos-asignados btn-toolbar-cupos'>
                  <ButtonNominacionMultiple
                    variant='contained'
                    style={{ color: COLORES.orange.medium, width: '100%' }}
                    size='small'
                    onClick={() => { dispatch(openDialogNominacionMultiple()) }}
                  >
                    NOMINACIÓN MÚLTIPLE
                  </ButtonNominacionMultiple>
                </div>
              }
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', margintop: '2px' }}>
              {data.length > 0 && bloqueados.length > 0 && <div
                style={{
                  margin: '5px 8px 0 0',
                  fontWeight: 'bold',
                  fontSize: '0.9rem',
                  color: '#707171'
                }}
              >
                <span style={{ borderBottom: '2px solid', borderColor: '#707171' }}>
                  {(bloqueados.length === 1) ? `${bloqueados.length} cupo bloqueado` : `${bloqueados.length} cupos bloqueados`}
                </span>
              </div>
              }
            </div>
          </div>
          <div style={{ margin: '8px 10px' }}>
            <PdfDownloadLinkReporteLaridae filas={data} columnas={CUPOS_ASIGNADOS_TO_PRINT} titulo={'Cupos asignados'} />
          </div>
        </>
      )

      const columnas = getColumnasCuposAsignados(roles)

      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: `Cupos asignados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false, pagination: false, tableBodyMaxHeight: '599px' }
        },
        id: TABLE_CUPOS
      })
    }
  }
}

export function updateTablaDeCuposDisponibles () {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_CUPOS_DISPONIBLES
    })
    getCuposVigentesDisponibles().then(callback)
    function callback (data) {
      dispatch({ type: 'UPDATE_MUITABLE_CUPOS_DISPONIBLES', data })
      const customToolbar = () => null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DISPONIBLES,
          data: data,
          title: `Cupos asignados disponibles para Nominar`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false, pagination: false, search: false, tableBodyMaxHeight: '599px' }
        },
        id: TABLE_CUPOS_DISPONIBLES
      })
    }
  }
}

export function updateTablaCacheDeCuposNominados () {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CACHE_CUPOS_A_NOMINAR
    })
    CupoService.getCuposNominadosCache(state.auth.username).then(callback)
    function callback (data) {
      dispatch({ type: 'UPDATE_MUITABLE_CUPOS_CACHE', data })
      const customToolbar = () => null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_NOMINADO_CACHE,
          data: data,
          title: `Cupos listos para ser Nominados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false, pagination: false, filter: false, search: false, tableBodyMaxHeight: '599px' }
        },
        id: TABLA_CACHE_CUPOS_A_NOMINAR
      })
    }
  }
}

export function showCloseNotificacion (roles, userName) {
  return (dispatch) => {
    dispatch({ type: 'CLOSE_NOTIFICACION' })
    dispatch({
      type: 'CLOSE_DIALOG',
      id: 'NOMINAR_CUPO'
    })
    dispatch(updateTablaDeAsignacionDeCupos(roles))
    dispatch(clearNominacionCache(userName))
    dispatch({ type: 'RESET_MUITABLE_CUPOS_CACHE' })
    dispatch({ type: 'RESET_MUITABLE_CUPOS_DISPONIBLES' })
  }
}

export function updateTablaDeRenominacionDeCupos (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: TABLE_CUPOS_NOMINADOS
    })
  }
}

export function parseDataCuposNominados (data) {
  const parsedData = []
  if (data) {
    data.data.forEach(entry => {
      const registro = []
      let vigente = false

      const fechaEmision = (entry.fechaDeEmisionDate).split('-')
      var dEmision = fechaEmision[2]
      var mEmision = fechaEmision[1] < 10 ? parseInt('0' + fechaEmision[1]) : fechaEmision[1]
      var yEmision = fechaEmision[0]

      var fechaActual = new Date()
      var dActual = fechaActual.getDate()
      var mActual = fechaActual.getMonth() + 1
      var yActual = fechaActual.getFullYear()

      if (yEmision >= yActual) {
        if (mEmision > mActual) {
          vigente = true
        } else if (parseInt(mEmision) === parseInt(mActual)) {
          if (dEmision >= dActual) {
            vigente = true
          }
        }
      }

      // Vigencia del cupo para poder acceder a las operaciones sobre el mismo
      registro.push({ ...entry, vigente: vigente })
      parsedData.push({ ...entry, cupo: registro[0] })
    })
  }
  return parsedData
}

export function actualizarTablaCuposNominados (fechaD, fechaH, rol = null) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_CUPOS_NOMINADOS
    })
    CupoService.getCuposNominadosEntreFechas(fechaD, fechaH).then(callback)
    function callback (d) {
      const data = parseDataCuposNominados(d)
      const customToolbar = pdfCustomToolbarGenerator(
        'Cupos nominados',
        data,
        CUPOS_NOMINADOS_TO_PRINT,
        'portrait'
      )
      const columnas = getColumnasCuposNominados(rol)
      return dispatch(updateTablaDeRenominacionDeCupos({
        columns: columnas,
        data,
        title: 'Detalle de cupos nominados',
        isLoading: false,
        extraOptions: {
          customToolbar,
          print: false,
          pagination: false,
          tableBodyMaxHeight: '520px'
        }
      })
      )
    }
  }
}

export function closeDialogNominacion () {
  return dispatch => {
    dispatch({
      type: 'CLOSE_NOMINACION'
    })
  }
}

export function closeDialogRenominacion () {
  return dispatch => {
    dispatch({
      type: 'CLOSE_RENOMINACION'
    })
  }
}

export function showToast (message, id, title, error = false) {
  return dispatch => {
    const onClose = () => {
      dispatch({
        type: 'CLOSE_TOAST',
        id: id
      })
    }
    dispatch({
      type: 'OPEN_TOAST',
      id: id,
      show: true,
      error: error,
      title: title,
      message: message,
      onClose: onClose
    })
  }
}

// export function setTipoCupo(tipoCupo) {
//   //TODO CHECK HOW TO RETRIEVE THE TYPES FROM DE DATABASE
//   //MOCKED FOR NOW
//   return dispatch => {
//     dispatch({
//       type: "CHOSEN_TIPO_CUPO",
//       tipoCupo: tipoCupo
//     });
//   };
// }

export function updateCurrentCupo (cupo) {
  return dispatch => {
    const clave = {
      fecha_de_emision: cupo.fechaDeEmision,
      exportador: cupo.cuitExportador,
      cereal: cupo.claveCereal,
      tipo_cupo: cupo.tipo[0]
    }
    CupoService.getCupo(clave)
      .then(extractCupoFromResponse())
      .then(cupo => {
        Autocomplete.directSearch('exportador', cupo['exportador']).then(
          matches => {
            let match = matches && matches.shift()
            match = match || ''
            cupo.exportadorFormField = match
            cupo.tipoCupoFormField = CupoUtils.parseTipoCupo(cupo['tipoCupo'])
            setCurrentCupo(cupo)(dispatch)
          }
        )
      })
  }
}

function extractCupoFromResponse () {
  return response => Promise.resolve(response.data[0])
}

export function setCurrentCupoRenominando (cupo) {
  return dispatch => {
    dispatch(
      initialize(FORM_NOMINACION_CUPO, {
        cantidadRenominada: cupo.cantidadDisponible
      })
    )
    dispatch({
      type: 'SET_CURRENT_CUPO_RENOMINANDO',
      cupo: cupo
    })
  }
}

export function setCurrentCupo (cupo) {
  return dispatch => {
    dispatch(
      initialize(FORM_CUPO, {
        fechaDeCupo: cupo['fechaDeEmision'],
        exportador: cupo['exportadorFormField'],
        'Tipo de Cupo': cupo['tipoCupo'],
        cantidad: cupo['cantidadAsignada'], // actualizar cantidad asignada
        cereal: cupo['cereal']
      })
    )
    dispatch({
      type: 'SET_CURRENT_CUPO',
      cupo: cupo
    })
  }
}

export function deleteCupo (currentCupo) {
  return (dispatch, getState) => {
    const state = getState()
    const confirmCallback = () => {
      CupoService.bajaCupos(
        CupoUtils.extractClaveFromCupo(currentCupo),
        currentCupo.tipo.toLowerCase()
      )
        .then(() => {
          dispatch({
            type: 'DELETED_CURRENT_CUPO',
            cupo: currentCupo
          })
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CONFIRM_ELIMINAR_CUPO_ASIGNADO'
          })
          toast.success('Cupo eliminado correctamente')
          clearCurrentCupo()
          getCuposVigentes().then(data => {
            updateTablaDeAsignacionDeCupos(state.auth.roles)(dispatch)
          })
        })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CONFIRM_ELIMINAR_CUPO_ASIGNADO'
          })
          console.log(error)
          toast.error('Error eliminando el cupo.')
        })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'CONFIRM_ELIMINAR_CUPO_ASIGNADO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'CONFIRM_ELIMINAR_CUPO_ASIGNADO',
      maxWidth: 'xs',
      content: <DialogView
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        title='Eliminar cupo'
        content={<DialogConfirmacionContent
          message='¿Esta seguro que desea eliminar el cupo seleccionado?'
        />
        }
      />
    })
  }
}

export function deleteCupoNominado (currentCupo) {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      CupoService.bajaCupoNominado(
        CupoUtils.parseFormToDeleteNomincacionCupo(currentCupo).clave
      )
        .then(() => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CONFIRM_ELIMINAR_CUPO_NOMINADO'
          })
          toast.success('Cupo nominado borrado correctamente')
          getCuposNominados().then(data => {
            updateTablaDeRenominacionDeCupos({ isLoading: false, data })(dispatch)
          })
        })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CONFIRM_ELIMINAR_CUPO_NOMINADO'
          })
          console.log(error)
          toast.error('Error eliminando cupos nominados')
        })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'CONFIRM_ELIMINAR_CUPO_NOMINADO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'CONFIRM_ELIMINAR_CUPO_NOMINADO',
      maxWidth: 'xs',
      content: <DialogView
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        title='Eliminar cupos nominados'
        content={<DialogConfirmacionContent
          message='¿Esta seguro que desea eliminar los cupos nominados seleccionados?'
        />
        }
      />
    })
  }
}

export function clearCurrentCupo () {
  return dispatch => {
    dispatch({
      type: 'SET_CURRENT_CUPO',
      cupo: null
    })
    dispatch(initialize(FORM_CUPO, EMPTY_CUPO))
  }
}

export function bloquearCupos (cupo, habilitado) {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      dispatch(cambiarEstadoHabilitadoCupo(cupo, habilitado))
        .then(() => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CONFIRM_BLOQUEAR_CUPO_NOMINADO'
          })
          toast.success('Cupos bloqueados correctamente')
        })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CONFIRM_BLOQUEAR_CUPO_NOMINADO'
          })
          console.log(error)
          toast.error('Error bloqueando cupos')
        })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'CONFIRM_BLOQUEAR_CUPO_NOMINADO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'CONFIRM_BLOQUEAR_CUPO_NOMINADO',
      maxWidth: 'xs',
      content: <DialogView
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        title='Bloquear cupos'
        content={<DialogConfirmacionContent
          message='¿Esta seguro que desea bloquear los cupos seleccionados?'
        />
        }
      />
    })
  }
}

export function cambiarEstadoHabilitadoCupo (cupo, habilitado) {
  return async (dispatch, getState) => {
    const state = getState()
    const clave = CupoUtils.extractClaveFromCupo(cupo)
    CupoService.modificarBloqueoCupos(clave, cupo.tipo[0], habilitado)
      .then(() => {
        getCuposVigentes().then(data => {
          updateTablaDeAsignacionDeCupos(state.auth.roles)(dispatch)
        })
        return cupo
      })
      .catch(error => {
        console.log(error)
        return error
      })
  }
}

export function saveCuposVigentes (data) {
  return dispatch => {
    dispatch({
      type: 'SAVE_CUPOS_VIGENTES',
      data
    })
  }
}

// Permite el bloqueo total de cupos vigentes o
// filtrado por determinados cereales y/o exportadores
export function bloqueoDeCupos () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUPO)(state)
    const cupos = state.cupos.cuposVigentes

    if (formValues) {
      // Bloqueo de todos los cupos vigentes
      if (formValues.bloqueoTotal) {
        cupos.forEach((cupo) => {
          dispatch(cambiarEstadoHabilitadoCupo(cupo, false))
        })
      } else {
        // Bloqueo filtrado de los cupos vigentes
        const dataEntreFechas = []

        // Filtro por fechas
        moment.locale('ar-AR')
        cupos.forEach((cupo) => {
          if (moment(cupo.fechaDeEmision).format('YYYY/MM/DD') >= formValues.fechaD && moment(cupo.fechaDeEmision).format('YYYY/MM/DD') <= formValues.fechaH) {
            dataEntreFechas.push(cupo)
          }
        })

        // Bloquea todos los cupos vigentes de un determinado cereal y/o exportador
        const cereales = formValues.cereal
        const exportadores = formValues.exportador
        let data = []

        if (cereales.length > 0 && exportadores.length > 0) {
          cereales.forEach(cereal => {
            dataEntreFechas.forEach(cupo => {
              exportadores.forEach(exportador => {
                if (cupo.claveCereal === cereal && cupo.exportador === exportador) {
                  data.push(cupo)
                }
              })
            })
          })
        } else if (cereales.length > 0) {
          cereales.forEach(cereal => {
            dataEntreFechas.forEach(cupo => {
              if (cupo.claveCereal === cereal) {
                data.push(cupo)
              }
            })
          })
        } else if (exportadores.length > 0) {
          exportadores.forEach(exportador => {
            console.log(exportador)
            data = dataEntreFechas.filter(cupo => cupo.exportador === exportador)
          })
        } else {
          data = dataEntreFechas
        }

        data.forEach(cupo => {
          dispatch(cambiarEstadoHabilitadoCupo(cupo, false))
        })
      }
    }
  }
}

// Desbloquea todos los cupos vigentes sin filtar por cereal, exportador ni fecha
export function desbloqueoDeCupos () {
  return (dispatch, getState) => {
    const state = getState()
    const cupos = state.cupos.cuposVigentes
    cupos.forEach(cupo => {
      dispatch(cambiarEstadoHabilitadoCupo(cupo, true))
    })
  }
}

export function ocultarDialogCorreo () {
  return (dispatch, getState) => {
    dispatch({ type: 'RECEIVE_MOSTRAR_DIALOG_ADD_CORREO', estado: false })
  }
}

export function mostrarDialogEditCorreo () {
  return (dispatch, getState) => {
    dispatch({ type: 'RECEIVE_MOSTRAR_DIALOG_EDIT_CORREO', estado: true })
  }
}

export function ocultarDialogEditCorreo () {
  return (dispatch, getState) => {
    dispatch({ type: 'RECEIVE_MOSTRAR_DIALOG_EDIT_CORREO', estado: false })
  }
}

export function isValidEmail (estado) {
  return (dispatch) => {
    dispatch({ type: 'CORREO_VALIDO', estado })
  }
}

export function desinformarStopQ (data) {
  return async (dispatch, getState) => {
    // const state = getState()
    // const roles = state.auth.roles

    if (data) {
      const codigoDeCupo = data.codigoCupo.trim()
      const cupo = await CupoService.getCupoNominadoXCodigo(codigoDeCupo)
      const datosDeCupo = {
        codigoCupo: codigoDeCupo,
        fechaCupo: data.fechaCupo,
        grano: 23,
        idCupo: cupo.idCupoStopq,
        exportador: cupo.exportador
      }

      CupoService.borrarCupoDeStopQ(datosDeCupo)
        .then((data) => {
          console.log('data', data)
          if (data && data.borrarCupoDeStopq) {
            CupoService.liberarCupoNominado(codigoDeCupo)
              .then((result) => {
                console.log('result', result)
                if (result && result.liberarCupoNominado === 1) {
                  toast.success(`Cupo ${codigoDeCupo} liberado correctamente`)
                  // Se comenta para no actualizar la tabla de cupos asignados y perder filtros asignados
                  // const fecha = moment(new Date()).format('YYYY-MM-DD')
                  // dispatch(actualizarDatosParaMuiTable(fecha, fecha, roles))
                } else {
                  toast.error(`Error al liberar el cupo ${codigoDeCupo}`)
                }
              })
          }
        })
    }
  }
}

export function actualizarExportador () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUPO)(state)
    console.log(formValues)
    const exportador = formValues.exportador
    if (formValues) {
      dispatch({ type: 'ACTUALIZAR_EXPORTADOR', exportador })
      dispatch(actualizarCorreosExportador(parseEntityId(exportador)))
    }
  }
}

export function actualizarCorreosExportador (exportador) {
  return (dispatch) => {
    CorreoElectronico.getCorreoExportador(exportador)
      .then(data => {
        dispatch({ type: 'SET_CORREOS_SELECCIONADOS', data })
      })
  }
}

export function obtenerContactosExportador () {
  return (dispatch, getState) => {
    const state = getState()
    CorreoElectronico.getCorreoExportador(parseEntityId(state.cupos.exportador))
      .then(data => {
        dispatch({ type: 'SET_CORREOS_SELECCIONADOS', data })
      })
  }
}

export function submitAsignacionDeCuposCache () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUPO)(state)
    if (!formValues) {
      toast.error('Todos los campos deben estar completos')
      dispatch(reset(FORM_CUPO))
      return
    }
    const cupoAsignado = CupoUtils.parseFormToApiNewCupo(formValues)
    cupoAsignado.cupo.exportador = parseEntityId(state.cupos.exportador)
    if (formValues.fechaD !== null && formValues.fechaH !== null &&
      cupoAsignado.cupo.exportador !== null) {
      const fechaD = moment(formValues.fechaD).format('YYYY-MM-DD')
      const fechaH = moment(formValues.fechaH).format('YYYY-MM-DD')
      const dias = moment(fechaH).diff(moment(fechaD), 'days')
      for (let i = 0; i <= dias; i++) {
        cupoAsignado.cupo.fechaDeEmision = moment(fechaD).add(i, 'days').format('YYYY-MM-DD')
        CupoService.asignarCuposCache(cupoAsignado)
          .then(response => {
            dispatch(reset(FORM_CUPO))
            dispatch(actualizarDatosCuposParaAsignarMuiTable())
          })
          .catch(error => {
            console.log(error)
            toast.error('Error asignando cupo')
            dispatch(reset(FORM_CUPO))
          })
      }
    } else {
      toast.info('Todos los campos deben estar completos')
    }
  }
}

export function submitNominacionDeCuposCache () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUPO_MULTIPLE)(state)
    if (!formValues) {
      toast.error('Todos los campos deben estar completos')
      dispatch(reset(FORM_CUPO_MULTIPLE))
      return
    }
    const datosDeCupo = state.cupos.datosDeCupo
    const usuario = state.auth.username
    const aNotificarCargador = state.cupos.aNotificarCargador
    const aNotificarCorredor = state.cupos.aNotificarCorredor
    let aUtilizar
    datosDeCupo.cargador = parseEntityId(formValues.remitenteComercial)
    datosDeCupo.razonSocialCargador = parseEntityName(formValues.remitenteComercial)
    datosDeCupo.corredor = parseEntityId(formValues.corredorComprador)
    datosDeCupo.razonSocialCorredor = parseEntityName(formValues.corredorComprador)
    datosDeCupo.cantidadNominada = formValues.cantidadNominada
    const datosDeNotificacion = {
      correoCargador: state.cupos.correoCargador,
      correoCorredor: state.cupos.correoCorredor,
      notificarCargador: (state.cupos.correoCargador !== null),
      notificarCorredor: (state.cupos.correoCorredor !== null)
    }
    const cuposANotificar = {
      ...datosDeCupo,
      ...datosDeNotificacion
    }
    if (datosDeNotificacion.notificarCargador) aNotificarCargador.push(cuposANotificar)
    if (datosDeNotificacion.notificarCorredor) aNotificarCorredor.push(cuposANotificar)
    if (datosDeCupo.cargador && datosDeCupo.corredor && datosDeCupo.cantidadNominada > 0) {
      CupoService.nominarCuposCache(datosDeCupo, datosDeNotificacion, usuario)
        .then(response => {
          if (response.error) {
            toast.error('Error al Nominar el cupo, ya existe una nominación pendiente')
          } else {
            dispatch(reset(FORM_CUPO_MULTIPLE))
            dispatch(updateTablaCacheDeCuposNominados())
          }
        })
        .catch(error => {
          console.log(error)
          toast.error('Error nominando cupos')
          dispatch(reset(FORM_CUPO_MULTIPLE))
        })
      if (state.cupos.cuposSeleccionados !== null) {
        const promises = []
        state.cupos.cuposSeleccionados.forEach(async (cupito) => {
          aUtilizar = await buscarCantidadesNominadasEnCache(state.cupos.cuposCacheNominados, cupito)
          console.log('cupito', cupito, aUtilizar)
          if ((cupito.cantidadDisponible - aUtilizar) > 0) {
            const datosDeCupoNew = {
              ...datosDeCupo,
              fechaDeEmision: cupito.fechaDeEmision,
              exportador: cupito.exportador,
              cuitExportador: cupito.cuitExportador,
              cantidadNominada: (formValues.cantidadNominada <= (cupito.cantidadDisponible - aUtilizar)) ? formValues.cantidadNominada : (cupito.cantidadDisponible - aUtilizar)
            }
            promises.push(CupoService.nominarCuposCache(datosDeCupoNew, datosDeNotificacion, usuario))
            // console.log(datosDeCupoNew)
          }
        })
        Promise.all(promises)
          .then((data) => {
            if (data.error) {
              toast.error('Error al Nominar el cupo, ya existe una nominación pendiente')
            } else {
              dispatch(updateTablaCacheDeCuposNominados())
              dispatch({ type: 'RESET_LISTA_CUPOS_SELECCIONADOS' })
              dispatch({ type: 'ACTUALIZAR_CUPOS_A_NOTIFICAR_CARGADOR', aNotificarCargador })
              dispatch({ type: 'ACTUALIZAR_CUPOS_A_NOTIFICAR_CORREDOR', aNotificarCorredor })
            }
          })
          .catch(error => {
            console.log(error)
            toast.error('Error nominando cupos')
            dispatch(reset(FORM_CUPO_MULTIPLE))
          })
      }
    } else {
      toast.info('Todos los campos deben estar completos')
    }
  }
}

export async function buscarCantidadesNominadasEnCache (cuposCache, cupito) {
  let cantidad = 0
  cuposCache.forEach((cupoCache) => {
    if (cupoCache.fechaDeEmision === cupito.fechaDeEmision &&
      cupoCache.cereal === cupito.claveCereal &&
      cupoCache.exportador === cupito.cuitExportador) {
      cantidad = cantidad + cupoCache.cantidad
    }
  })
  console.log('cantidad', cantidad)
  return cantidad
}

export function onSubmitNewContacto () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CONTACTO)(state)
    const exportador = parseEntityId(state.cupos.exportador)
    console.log(formValues)
    if (formValues) {
      CorreoElectronico.agregarCorreoExportador(formValues.nombre, formValues.correoElectronico, exportador)
        .then(response => {
          dispatch(reset(FORM_CONTACTO))
          dispatch(ocultarDialogCorreo())
          dispatch(actualizarCorreosMuiTable(exportador))
          dispatch(actualizarCorreosExportador(exportador))
          toast.info('Se agregó el contacto exitosamente.')
        })
        .catch(error => {
          console.log(error)
          toast.error('Error')
        })
    } else {
      toast.info('Todos los campos deben estar completos')
      // dispatch(reset(FORM_CONTACTO))
    }
  }
}

export function onSubmitUpdateContacto (id) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_EDICION_CONTACTO)(state)
    const exportador = parseEntityId(state.cupos.exportador)
    console.log(formValues)
    if (formValues) {
      CorreoElectronico.actualizarCorreoExportador(id, formValues.nombre, formValues.correoElectronico, exportador)
        .then(response => {
          dispatch(reset(FORM_EDICION_CONTACTO))
          dispatch(ocultarDialogCorreo())
          dispatch(actualizarCorreosMuiTable(exportador))
          dispatch(actualizarCorreosExportador(exportador))
          toast.info('Se actualizó el contacto exitosamente.')
        })
        .catch(error => {
          console.log(error)
          toast.error('Error')
        })
    } else {
      toast.info('Todos los campos deben estar completos')
    }
  }
}

export function clearCupoCache (exportador) {
  return dispatch => {
    CupoService.deleteCuposAsignadosCacheXExportador(exportador)
      .then(response => {
        console.log('Cache de exportador eliminada', exportador)
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export function clearNominacionCache (usuario) {
  return dispatch => {
    CupoService.deleteCuposNominadosCache(usuario)
      .then(response => {
        console.log('Cache de nominacion eliminada', usuario)
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export function eliminarCorreo (id) {
  return (dispatch, getState) => {
    const state = getState()
    CorreoElectronico.eliminarCorreoExportador(id)
      .then(response => {
        toast.info('Se eliminó correctamente el Correo')
        dispatch(actualizarCorreosMuiTable(parseEntityId(state.cupos.exportador)))
        dispatch(actualizarCorreosExportador(parseEntityId(state.cupos.exportador)))
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al eliminar Correo')
      })
  }
}

export function editarCorreo (id, formChange) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_CONTACTO' })
    CorreoElectronico.buscarCorreoExportador(id)
      .then(contacto => {
        dispatch({ type: 'RECEIVE_CONSULTA_CONTACTO', contacto })
        formChange('nombre', contacto.nombre)
        formChange('correoElectronico', contacto.correoElectronico)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CONSULTA_CONTACTO',
        contacto: null
      }))
  }
}

export function precargarDatosNominacion (cupo) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUPO_MULTIPLE)(state)
    if (cupo === null || cupo.length === 0) {
      toast.error('Imposible agregar a la nominación')
      return
    }
    const datosDeCupo = cupo
    dispatch({
      type: 'RECEIVE_PRECARGA_NOMINACION',
      datosDeCupo: datosDeCupo
    })
    dispatch({ type: 'RESET_CANTIDAD_ACTUAL' })
    dispatch(actualizarCuposDisponibles(datosDeCupo, (formValues && formValues.cantidadNominada !== undefined &&
      formValues.cantidadNominada >= 0) ? formValues.cantidadNominada : 0))
    dispatch(actualizarCuposFiltrados(datosDeCupo))
  }
}

export function actualizarCuposDisponibles (datosDeCupo, cantidad) {
  return async (dispatch, getState) => {
    const state = getState()
    const { cantidadDisponible } = datosDeCupo
    let cantidadActual = parseInt(cantidadDisponible) - parseInt(cantidad)
    if (state.cupos.cuposCacheNominados !== null) {
      state.cupos.cuposCacheNominados.forEach((cupito) => {
        if (cupito.fechaDeEmision === datosDeCupo.fechaDeEmision &&
          cupito.cereal === datosDeCupo.claveCereal &&
          cupito.exportador === datosDeCupo.cuitExportador) {
          cantidadActual = cantidadActual - cupito.cantidad
        }
      })
    }
    // Cantidad actual disponible para utilizar
    dispatch({
      type: 'ACTUALIZAR_PRECARGA_NOMINACION',
      cantidadActual
    })
  }
}

export function actualizarCuposFiltrados (datosDeCupo) {
  return (dispatch, getState) => {
    if (datosDeCupo !== null) {
      CupoService.getCuposVigentesConFiltro(datosDeCupo.claveCereal)
        .then((response) => {
          const cuposFiltrados = response.filter((cupo) => (cupo.fechaDeEmision === datosDeCupo.fechaDeEmision &&
            cupo.cuitExportador !== datosDeCupo.cuitExportador) || cupo.fechaDeEmision !== datosDeCupo.fechaDeEmision)
          dispatch({
            type: 'ACTUALIZAR_CUPOS_VIGENTES_FILTRADOS',
            cuposVigentesFiltrados: cuposFiltrados
          })
        })
    }
  }
}

export function eliminarAsignacionCache (Data) {
  return (dispatch, getState) => {
    if (Data === null || Data.length === 0) {
      toast.error('Imposible eliminar la asignación')
      return
    }
    CupoService.deleteCuposAsignadosCacheIndividual(Data[0], Data[1], Data[2], Data[4])
      .then(response => {
        toast.info('Se eliminó la asignación seleccionada')
        dispatch(actualizarDatosCuposParaAsignarMuiTable())
      })
      .catch(error => {
        console.log(error)
        toast.error('Error eliminado cupo')
        dispatch(reset(FORM_CUPO))
      })
  }
}

export function eliminarNominacionCache (data) {
  return (dispatch, getState) => {
    const state = getState()
    if (data === null || data.length === 0) {
      toast.error('Imposible eliminar la Nominación')
      return
    }
    const datosDeCupoCache = {
      fechaDeEmision: data[0],
      cereal: data[1],
      exportador: data[10],
      cargador: data[4],
      corredor: data[6],
      usuario: state.auth.username
    }
    CupoService.deleteCuposNominadosCacheIndividual(datosDeCupoCache)
      .then(response => {
        toast.info('Se eliminó la nominación seleccionada')
        dispatch(updateTablaCacheDeCuposNominados())
      })
      .catch(error => {
        console.log(error)
        toast.error('Error eliminando nominación')
        dispatch(reset(FORM_CUPO_MULTIPLE))
      })
  }
}

export function modificarCantidadNominacionCache (data, nuevaCantidad) {
  return (dispatch, getState) => {
    if (data === null || data.length === 0) {
      toast.error('Imposible modificar la cantidad')
      return
    } else if (data.cantidadNominada === nuevaCantidad) {
      toast.info('La cantidad a modificar debe ser distinta a la actual')
      return
    }
    const datosDeCupoCache = {
      fechaDeEmision: data.fechaDeEmision,
      cereal: data.cereal,
      exportador: data.exportador,
      cargador: data.cargador,
      corredor: data.corredor,
      cantidadNominada: nuevaCantidad,
      usuario: data.usuario
    }
    CupoService.modificarCantidadCuposNominadosCacheIndividual(datosDeCupoCache)
      .then((response) => {
        toast.info('Se modificó la cantidad de la nominación seleccionada')
        dispatch(updateTablaCacheDeCuposNominados())
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al modificar la cantidad de la nominación')
        dispatch(reset(FORM_EDICION_CANTIDAD_CUPO))
      })
  }
}

export function submitAsignacionDeCupos () {
  return (dispatch, getState) => {
    const state = getState()
    const notificarPorCorreo = state.cupos.notificarPorCorreo
    const enviarATodos = state.cupos.enviarATodos
    const listaDeContactos = state.cupos.listaDeContactos
    const cupoAsignado = (nuevoCupo) => ({
      cupo: {
        fechaDeEmision: nuevoCupo.fechaDeEmision,
        exportador: nuevoCupo.exportador,
        cereal: nuevoCupo.cereal,
        cantidadAsignada: nuevoCupo.cantidadAsignada
      },
      tipo: nuevoCupo.tipoCupo
    })
    if (state.cupos.exportador !== null) {
      CupoService.getCuposAsignadosCache()
        .then(data => {
          if (data.length > 0) {
            const promises = []
            data.forEach(nuevoCupo => {
              promises.push(CupoService.asignarCupos(cupoAsignado(nuevoCupo)))
            })
            Promise.all(promises)
              .then(response => {
                dispatch(reset(FORM_CUPO))
                getCuposVigentes().then(data => {
                  updateTablaDeAsignacionDeCupos(state.auth.roles)(dispatch)
                })
                if (notificarPorCorreo) {
                  if (enviarATodos) {
                    CorreoElectronico.enviarTotalCuposAExportadores(parseEntityId(state.cupos.exportador))
                      .then(data => {
                        const cupoMsg = data[0].enviarTotalCuposAExportadores.substr(1, data[0].enviarTotalCuposAExportadores.length - 2).split(',')
                        toast.info(cupoMsg[2])
                        dispatch(clearCupoCache(parseEntityId(state.cupos.exportador)))
                      })
                      .catch((error) => {
                        console.log(error)
                      })
                  } else {
                    // Envio solo a contactos seleccionados
                    // console.log('Solo contactos seleccionados', listaDeContactos)
                    const sel = []
                    if (listaDeContactos !== null && listaDeContactos.length > 0) {
                      listaDeContactos.forEach(contacto => {
                        console.log(contacto.id)
                        sel.push(contacto.id)
                      })
                    }
                    CorreoElectronico.enviarSeleccionCuposAExportadores(parseEntityId(state.cupos.exportador), sel)
                      .then(data => {
                        const cupoMsg = data[0].enviarSeleccionCuposAExportadores.substr(1, data[0].enviarSeleccionCuposAExportadores.length - 2).split(',')
                        toast.info(cupoMsg[2])
                        dispatch(clearCupoCache(parseEntityId(state.cupos.exportador)))
                      })
                      .catch((error) => {
                        console.log(error)
                      })
                  }
                } else {
                  dispatch(clearCupoCache(parseEntityId(state.cupos.exportador)))
                }
                toast.success('Cupo asignado correctamente')
              })
              .catch(error => {
                console.log(error)
                toast.error('Error asignando cupo')
                dispatch(reset(FORM_CUPO))
                dispatch(clearCupoCache(parseEntityId(state.cupos.exportador)))
              })
          } else {
            toast.info('No hay cupos para asignar')
          }
          dispatch({ type: 'ACTUALIZAR_EXPORTADOR', exportador: null })
          dispatch(reset(FORM_CUPO))
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}

export function updateListaCuposSeleccionados (cupo) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_LISTA_CUPOS_SELECCIONADOS', cupo })
  }
}

export function updateListaContactos (contactos) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_LISTA_CONTACTOS', contactos })
  }
}

export function resetListaContactos () {
  return (dispatch) => {
    dispatch({ type: 'RESET_LISTA_CONTACTOS' })
  }
}

export function updateNotificarPorCorreo (estado) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_NOTIFICAR_POR_CORREO', estado })
  }
}

export function updateEnviarATodos (estado) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_ENVIAR_A_TODOS', estado })
  }
}

function parseCuposVigentes (data) {
  const parsedData = []
  data.data.forEach(entry => {
    parsedData.push({ ...entry, cupo: entry })
  })
  return parsedData
}

export async function getCuposVigentes () {
  return parseCuposVigentes(await CupoService.getCupos())
}

async function getCuposVigentesDisponibles () {
  return parseCuposVigentes(await CupoService.getCuposVigentesDisponibles())
}

async function getCuposNominados () {
  return parseCuposNominados(await CupoService.getCuposNominados())
}

export function buscarCorreoCargador (cargador) {
  return (dispatch, getState) => {
    return CorreoCargador.getCorreoCargador(parseEntityId(cargador))
      .then((data) => {
        if (data) {
          dispatch({ type: 'REQUEST_CORREO_CARGADOR', data: data.correoElectronico })
          return data
        } else {
          toast.error('Error al obtener el Correo Electrónico del Cargador')
        }
      })
  }
}

export function buscarCorreoCorredor (corredor) {
  return (dispatch, getState) => {
    return CorreoCorredor.getCorreoCorredor(parseEntityId(corredor))
      .then((data) => {
        if (data) {
          dispatch({ type: 'REQUEST_CORREO_CORREDOR', data: data.correoElectronico })
          return data
        } else {
          toast.error('Error al obtener el Correo Electrónico del Corredor')
        }
      })
  }
}

export function buscarCorreoCuitCargador (cargador) {
  return (dispatch, getState) => {
    return CorreoCargador.getCorreoCargador(cargador)
      .then((data) => {
        if (data) {
          dispatch({ type: 'REQUEST_CORREO_CARGADOR', data: data.correoElectronico })
          return data
        } else {
          toast.error('Error al obtener el Correo Electrónico del Cargador')
        }
      })
  }
}

export function buscarCorreoCuitCorredor (corredor) {
  return (dispatch, getState) => {
    return CorreoCorredor.getCorreoCorredor(corredor)
      .then((data) => {
        if (data) {
          dispatch({ type: 'REQUEST_CORREO_CORREDOR', data: data.correoElectronico })
          return data
        } else {
          toast.error('Error al obtener el Correo Electrónico del Corredor')
        }
      })
  }
}

export function resetCorreoCargador () {
  return (dispatch, getState) => {
    dispatch({ type: 'RESET_CORREO_CARGADOR' })
  }
}

export function resetCorreoCorredor () {
  return (dispatch, getState) => {
    dispatch({ type: 'RESET_CORREO_CORREDOR' })
  }
}

function parseCuposNominados (data) {
  const parsedData = []
  if (data) {
    data.data.forEach(entry => {
      const registro = []
      let vigente = false
      const fechaEmision = (entry.fechaDeEmisionDate).split('-')
      var dEmision = fechaEmision[2]
      var mEmision = fechaEmision[1] < 10 ? parseInt('0' + fechaEmision[1]) : fechaEmision[1]
      var yEmision = fechaEmision[0]

      var fechaActual = new Date()
      var dActual = fechaActual.getDate()
      var mActual = fechaActual.getMonth() + 1
      var yActual = fechaActual.getFullYear()

      if (yEmision >= yActual) {
        if (mEmision > mActual) {
          vigente = true
        } else if (parseInt(mEmision) === parseInt(mActual)) {
          if (dEmision >= dActual) {
            vigente = true
          }
        }
      }

      // Vigencia del cupo para poder acceder a las operaciones sobre el mismo
      registro.push({ ...entry, vigente: vigente })
      parsedData.push({ ...entry, cupo: registro[0] })
    })
  }
  return parsedData
}

export function submitNominacionDeCuposMultiples () {
  return async (dispatch, getState) => {
    const state = getState()
    const promisesCupos = []
    const promisesCorreosCargador = []
    const promisesCorreosCorredor = []
    const aNotificarCargador = state.cupos.aNotificarCargador
    const aNotificarCorredor = state.cupos.aNotificarCorredor
    let cupo
    if (state.cupos.cuposCacheNominados !== null) {
      state.cupos.cuposCacheNominados.forEach((cupito) => {
        cupo = {
          exportador: cupito.exportador,
          cereal: cupito.cereal,
          fecha_de_emision: cupito.fechaDeEmision,
          cantidad_asignada: cupito.cantidad,
          cargador: (cupito.cargador) ? cupito.cargador : null,
          corredor: (cupito.corredor) ? cupito.corredor : null
        }
        promisesCupos.push(CupoService.nominarCupos({
          ...cupo,
          fecha_de_emision: cupito.fechaDeEmision
        }))
      })
      await Promise.all(promisesCupos)
        .then(async response => {
          if (!response.error) {
            moment.locale('ar-AR')
            toast.success(`Cupos nominados correctamente`)
            // Enviar emails de notificacion
            if (aNotificarCargador !== null) {
              aNotificarCargador.forEach((cupito) => {
                cupo = {
                  exportador: cupito.cuitExportador,
                  cereal: cupito.claveCereal,
                  fecha_de_emision: cupito.fechaDeEmision,
                  cantidad_asignada: cupito.claveCereal,
                  cargador: (cupito.cargador) ? cupito.cargador : null,
                  corredor: (cupito.corredor) ? cupito.corredor : null
                }
                promisesCorreosCargador.push(CorreoCargador.enviarResumenCuposACargadores(cupo, cupito.correoCargador))
              })
            }
            if (aNotificarCorredor !== null) {
              aNotificarCorredor.forEach((cupito) => {
                cupo = {
                  exportador: cupito.cuitExportador,
                  cereal: cupito.claveCereal,
                  fecha_de_emision: cupito.fechaDeEmision,
                  cantidad_asignada: cupito.cantidadDisponible,
                  cargador: (cupito.cargador) ? cupito.cargador : null,
                  corredor: (cupito.corredor) ? cupito.corredor : null
                }
                promisesCorreosCorredor.push(CorreoCorredor.enviarResumenCuposACorredores(cupo, cupito.correoCorredor))
              })
            }
          } else {
            toast.error(`Los cupos no fueron nominados`)
            dispatch({ type: 'UPDATE_IS_REQUESTING_CUPOS', isRequestingCupos: false })
          }
        })
        .catch(error => {
          dispatch(reset(FORM_CUPO_MULTIPLE))
          console.log(error)
          toast.error(`Error nominando cupos`)
        })

      await Promise.all(promisesCorreosCargador)
        .then(response => {
          toast.info(`Se enviaron notificaciones a Cargadores`)
        })
      await Promise.all(promisesCorreosCorredor)
        .then(response => {
          toast.info(`Se enviaron notificaciones a Corredores`)
        })
      dispatch(reset(FORM_CUPO_MULTIPLE))
      dispatch({ type: 'RESET_CUPOS_A_NOTIFICAR_CARGADOR' })
      dispatch({ type: 'RESET_CUPOS_A_NOTIFICAR_CORREDOR' })
      dispatch({ type: 'UPDATE_IS_REQUESTING_CUPOS', isRequestingCupos: false })
    } else {
      toast.error(`No hay cupos para nominar`)
    }
  }
}

export function submitNominacionDeCupos () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUPO)(state)
    if (!formValues) {
      toast.error('Todos los campos deben estar completos')
      dispatch(reset(FORM_CUPO))
      return
    }
    const currentCupo = state.cupos.cupoNominacion
    const cupoNominado = CupoUtils.parseFormToApiNominarCupo(
      formValues,
      currentCupo
    )

    const thisDay = moment(cupoNominado.cupo.fecha_de_emision, 'YYYY/MM/DD')
    if (cupoNominado.cupo.cantidad_asignada > 0) {
      CupoService.nominarCupos({
        ...cupoNominado.cupo,
        fecha_de_emision: thisDay.format('YYYY/MM/DD')
      })
        .then(response => {
          dispatch(reset(FORM_CUPO))
          closeDialogNominacion()(dispatch)
          getCuposVigentes().then(data => {
            updateTablaDeAsignacionDeCupos(state.auth.roles)(dispatch)
          })
          moment.locale('ar-AR')
          toast.success(`Cupos para el ${thisDay.format('L')} nominados correctamente`)
          // Enviar emails de notificacion
          if (state.cupos.correoCargador) CorreoCargador.enviarCuposACargadores(cupoNominado.cupo, state.cupos.correoCargador)
          if (state.cupos.correoCorredor) CorreoCorredor.enviarCuposACorredores(cupoNominado.cupo, state.cupos.correoCorredor)
          dispatch(reset(FORM_CUPO))
        })
        .catch(error => {
          dispatch(reset(FORM_CUPO))
          closeDialogNominacion()(dispatch)
          console.log(error)
          toast.error(`Error nominando cupos para el ${thisDay.format('L')}`)
        })
    } else {
      toast.error(`Debe seleccionar una cantidad a Nominar`)
    }
  }
}

export function submitRenominacionDeCupos () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_NOMINACION_CUPO)(state)
    if (!formValues) {
      toast.error('Todos los campos deben estar completos')
      dispatch(reset(FORM_CUPO))
    } else if (formValues.cantidadRenominada > 0) {
      const currentCupo = state.cupos.cupoRenominacion
      const cupoRenominado = CupoUtils.parseFormToApiRenominarCupo(
        formValues,
        currentCupo
      )
      CupoService.modificarCupoNominado(
        cupoRenominado.valores,
        cupoRenominado.clave
      )
        .then(response => {
          closeDialogRenominacion()(dispatch)
          getCuposNominados().then(data => {
            updateTablaDeRenominacionDeCupos({ isLoading: false, data })(dispatch)
            // Enviar emails de notificacion
            console.log('cupo actual', cupoRenominado.valores.cantidad_asignada)
            console.log('cupo anterior', currentCupo.cantidadAsignada)
            if (state.cupos.correoCargador) CorreoCargador.enviarModificacionCuposACargadores(cupoRenominado.valores, currentCupo.cantidadAsignada, state.cupos.correoCargador)
            if (state.cupos.correoCorredor) CorreoCorredor.enviarModificacionCuposACorredores(cupoRenominado.valores, currentCupo.cantidadAsignada, state.cupos.correoCorredor)
          })
          toast.success('Cantidad de cupos nominados modificados correctamente')
        })
        .catch(error => {
          closeDialogRenominacion()(dispatch)
          console.log(error)
          toast.error('Error modificando cantidad de cupos nominados')
        })
    } else {
      toast.error('La cantidad debe ser mayor a 0 y menor o igual la cantidad disponible')
    }
  }
}

export function openDialogBloqueoDeCupos () {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      bloqueoDeCupos()(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'BLOQUEOS_DE_CUPO'
      })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'BLOQUEOS_DE_CUPO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'BLOQUEOS_DE_CUPO',
      maxWidth: 'md',
      title: 'Bloqueo de cupos',
      content: <BloqueoDeCuposDialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
      />
    })
  }
}

export function openAsignacionCuposDialog () {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      submitAsignacionDeCupos()(dispatch, getState)
      clearCurrentCupo()(dispatch)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ASIGNAR_CUPO'
      })
    }
    const cancelCallback = () => {
      const state = getState()
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ASIGNAR_CUPO'
      })
      clearCurrentCupo()(dispatch)
      if (state.cupos.exportador !== null) {
        clearCupoCache(parseEntityId(state.cupos.exportador))(dispatch)
      }
      dispatch({ type: 'ACTUALIZAR_EXPORTADOR', exportador: null })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'ASIGNAR_CUPO',
      maxWidth: 'md',
      title: 'Nueva Asignacion',
      content: <NewAsignacionDialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
      />
    })
  }
}

export function openDialogModificacion (cupo) {
  return (dispatch, getState) => {
    updateCurrentCupo(cupo)(dispatch)
    console.log('Cupo a modificar', cupo)
    const confirmCallback = () => {
      submitModificacionDeCupos(CupoUtils.extractClaveFromCupo(cupo))(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'MODIFICAR_CUPO'
      })
      clearCurrentCupo()(dispatch)
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'MODIFICAR_CUPO'
      })
      clearCurrentCupo()(dispatch)
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'MODIFICAR_CUPO',
      maxWidth: 'md',
      content: <EditAsignacionDialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        currentCupo={cupo}
      />
    })
  }
}

export function submitModificacionDeCupos (clave) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUPO)(state)
    if (!formValues) {
      toast.error('Todos los campos deben estar completos')
      dispatch(reset(FORM_CUPO))
      return
    }
    const cupoModificado = CupoUtils.parseFormToApiNewCupo(formValues)
    CupoService.modificarCupos(clave, cupoModificado.tipo, cupoModificado.cupo)
      .then(() => {
        dispatch(reset(FORM_CUPO))
        toast.success('Cupo modificado correctamente')
        getCuposVigentes().then(data => {
          updateTablaDeAsignacionDeCupos(state.auth.roles)(dispatch)
        })
      })
      .catch(error => {
        console.log(error)
        toast.error('Error modificando cupos asignados')
        dispatch(reset(FORM_CUPO))
      })
  }
}

export function openDialogoDetalleCodigoDecupo () {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'CODIGO_DE_CUPO'
      })
      dispatch({ type: 'SET_CODIGO_DE_CUPO' })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'CODIGO_DE_CUPO',
      maxWidth: 'md',
      title: 'Detalle código de cupo',
      content: <DetalleCodigoDeCupo
        cancelCallback={cancelCallback}
      />
    })
  }
}

export function parseData (data = null, cpaCupo = null) {
  let parsedData = null

  if (data) {
    data.fechaDeCupo = moment(data.fechaCupo).format('DD/MM/YYYY')
    parsedData = data
  } else if (!data && (cpaCupo && cpaCupo.length > 0)) {
    const cpa = cpaCupo[0] // ultimo cpa con el codigo de cupo
    const fecha = new Date(cpa.fechaCupo * 1000)

    const codigoCupo = cpa.codigoCupo
    const fechaDeCupo = fecha.toLocaleDateString('es-ES')
    const cereal = cpa.cereal
    const cerealVariedad = cpa.cerealVariedad
    const exportador = cpa.exportador
    const cargador = cpa.titularDeCupo
    const corredor = cpa.corredorComprador
    const estadoCupoStopq = `Consumido con el número ${cpa.numero}`
    const arribo = cpa.estadoCarga ? (cpa.estadoCarga).toUpperCase() : ' '
    const fechaDeNominacion = ''
    const stopq = cpa.renspa
    const tipoCupo = cpa.tipoCupo

    const cupo = {
      codigoCupo,
      fechaDeCupo,
      cereal,
      cerealVariedad,
      exportador,
      cargador,
      corredor,
      tipoCupo,
      estadoCupoStopq,
      fechaDeNominacion,
      stopq,
      arribo
    }

    parsedData = cupo
  }

  return parsedData
}

export function getCodigoDeCupo (codigoDeCupo) {
  return (dispatch) => {
    Promise.all([
      CodigoDeCupo.getDetalleCodigoDeCupo(codigoDeCupo),
      Cpa.getCpaPorCodigoDeCupo(codigoDeCupo)
    ])
      .then(([codigo, cpa]) => {
        if (codigo || cpa.length > 0) {
          const data = parseData(codigo, cpa)
          dispatch({ type: 'RECEIVE_CODIGO_DE_CUPO', data })
          dispatch({ type: 'RECEIVE_CPA_POR_CODIGO', cpa })
          openDialogoDetalleCodigoDecupo()(dispatch)
        } else {
          toast.error('Código de cupo incorrecto o inexistente')
        }
      })
  }
}

export function parsedCuposAsignadosCereal (data) {
  const dataAgrupada = []

  if (data.length > 0) {
    data.forEach((entry) => {
      const claveCereal = entry.claveCereal.trim()
      const fecha = entry.fechaDeCupoDate

      if (!dataAgrupada[fecha]) {
        dataAgrupada[fecha] = {
          data: []
        }
      }
      dataAgrupada[fecha].data.push({
        cereal: entry.cereal,
        claveCereal: claveCereal,
        cuposAsignados: entry.cuposAsignados,
        tipo: entry.tipo,
        cantidadAsignada: entry.cantidadAsignada,
        cantidadUsada: entry.cantidadUsada,
        cantidadDisponible: entry.cantidadDisponible
      })
    })
  }

  console.log(dataAgrupada, 'data agrupada ')
  return dataAgrupada
}

export function obtenerDatosTablaCuposAsignados () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CUPOS_ASIGNADOS
    })

    CupoService.getCuposVigentesPorCereal()
      .then((d) => {
        const data = parsedCuposAsignadosCereal(d)
        const customToolbar = null

        const columnas = columnasCuposAsignados()
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: `Cupos asignados`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: { customToolbar, print: false, pagination: false, tableBodyMaxHeight: '599px' }
          },
          id: TABLA_CUPOS_ASIGNADOS
        })
      })
  }
}

export function actualizarDatosCuposParaAsignarMuiTable () {
  return dispatch => {
    // Tabla cahe de Cupos que seran asignados
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CUPOS_A_ASIGNAR
    })
    CupoService.getCuposAsignadosCache().then(callback)
    function callback (data) {
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'Cupos que serán asignados',
        data,
        COLUMNS_CUPOS_PARA_ASIGNAR_TO_PRINT,
        'landscape')}{<div />}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CUPOS_PARA_ASIGNAR,
          data: data,
          title: `Cupos que serán asignados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar,
            viewColumns: false,
            rowsPerPage: 15,
            rowsPerPageOptions: [15, 20],
            print: false,
            download: false,
            filter: false,
            search: false }
        },
        id: TABLA_CUPOS_A_ASIGNAR
      })
    }
  }
}

export function actualizarCorreosMuiTable (exportador) {
  return dispatch => {
    // Tabla de Correos del Exportador
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CORREOS_UPDATE
    })
    CorreoElectronico.getCorreoExportador(exportador).then(callback)
    function callback (data) {
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        '',
        data,
        COLUMNS_CORREOS_EXPORTADOR_TO_PRINT,
        'landscape')}{<Tooltip
          title={'Agregar Correo'}>
          <IconButton
            onClick={() => dispatch({ type: 'RECEIVE_MOSTRAR_DIALOG_ADD_CORREO', estado: true })}>
            <EmailIcon />
          </IconButton>
        </Tooltip>}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CORREOS_EXPORTADOR,
          data: data,
          title: ``,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar,
            viewColumns: false,
            rowsPerPage: 15,
            rowsPerPageOptions: [15, 20],
            jumpToPage: true,
            print: false,
            download: false,
            filter: false
            // onRowsSelect: (rowsSelected, allRows) => {
            //   allRows.forEach(indice => {
            //     console.log(data[indice.index].id, data[indice.index].nombre)
            //     console.log(rowsSelected)
            //   })
            // },
            // onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
            //   console.log(currentRowsSelected, allRowsSelected, rowsSelected)
            // },
            // onRowClick: (rowData, rowMeta) => {
            //   console.log(rowData, rowMeta)
            // },
            // onCellClick: () => {
            //   console.log('sadf')
            // },
            // onRowsDelete: () => {
            //   console.log('remove')
            // }
          }
        },
        id: TABLA_CORREOS_UPDATE
      })
    }
  }
}

export function obtenerCumplimientoCupos () {
  return (dispatch) => {
    ParametroInteger.getByNombre('CUMPLICU')
      .then((netoPromedio) => {
        const cumplimiento = netoPromedio['valor']
        dispatch({ type: 'RECEIVE_PROMEDIO_CUMPLIMIENTO', cumplimiento })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
